import styled from 'styled-components';

export const Actions = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '1.5rem',
  alignItems: 'center',
  justifyContent: 'space-between',
  fontSize: '1rem',
  fontWeight: 'bold',
  'p': {
    margin: 0
  }
}));